import React, { ErrorInfo } from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';

import { datadogLogger } from '@helpers/datadogLogger';

import ContentError from './ContentError';

type ContentErrorBoundaryProps = Omit<
  ErrorBoundaryProps,
  'FallbackComponent' | 'fallbackRender' | 'fallback'
> & {
  children: React.ReactNode;
  isErrorReload?: boolean;
};

const ContentErrorBoundary = ({
  children,
  isErrorReload = true,
  onError,
  ...restProps
}: ContentErrorBoundaryProps) => {
  const onErrorBoundaryCallback = (error: Error, info: ErrorInfo) => {
    datadogLogger(error, {
      errorSource: 'Content Error Boundary',
      description: 'error happened in onErrorBoundaryCallback',
      componentStack: info.componentStack,
      digest: info.digest,
    });

    onError?.(error, info);
  };

  return (
    <ErrorBoundary
      fallbackRender={({ resetErrorBoundary }) => (
        <ContentError isErrorReload={isErrorReload} resetErrorBoundary={resetErrorBoundary} />
      )}
      onError={onErrorBoundaryCallback}
      {...restProps}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ContentErrorBoundary;
